import { AuditCollection, Collection, CollectionNameMapping } from "@core/types";
 
export const COLLECTION_NAME_MAP: CollectionNameMapping = {
    [Collection.AUTH]: "Auth",
    [Collection.ALERT_CONFIG]: "Alert Policy",
    [Collection.GEO_PCI]: "Cell Information",
    [Collection.DEVICES]: "Devies",
    [Collection.DEVICE_ALARM]: "Device Alert",
    [Collection.DEVICE_CMD]: "Device Command",
    [Collection.DEVICE_GROUP]: "Device Group",
    [Collection.FILES]: "Files",
    [Collection.GROUPS]: "Groups",
    [Collection.LICENSES]: "Licenses",
    [Collection.PROFILE_TEMPLATE]: "Profile Template",
    [Collection.ROLES]: "Roles",
    [Collection.DEVICE_REPORTS]: "Reports",
    [Collection.RF_STANDARD]: "RF Standard",
    [Collection.SCHEDULES]: "Schedules",
    [Collection.TAGS]: "Tags",
    [Collection.TENANTS]: "Tenants",
    [Collection.API_CONSUMERS]: "Third Party API",
    [Collection.USERS]: "Users",
    [Collection.USAGES]: "Usages",
    [Collection.WEBHOOK_SETTINGS]: "Webhook Settings"
}